import { NgModule, InjectionToken , Provider } from '@angular/core';
import { BrowserUtils } from './utils';

function _window(): any {
	return window;
}

export const WINDOW: InjectionToken<string>  = new InjectionToken<string> ('WindowToken');

export abstract class WindowRef {
	get nativeWindow(): any {
		return null;
	}
}

class NodeWindowRef extends WindowRef {
	constructor() {
		super();
	}

	get nativeWindow(): any {
		return null;
	}
}

class BrowserWindowRef extends WindowRef {
	constructor() {
		super();
	}
	get nativeWindow(): any {
		return _window();
	}
}


let providers: Provider[];

// if (BrowserUtils.isBrowser()) {
	providers = [
		{ provide: WindowRef, useClass: BrowserWindowRef },
		{ provide: WINDOW, useFactory: _window },
	];
// }
// else {
// 	providers = [
// 		{ provide: WindowRef, useClass: NodeWindowRef },
// 		{ provide: WINDOW, useFactory: () => null },
// 	];
// }

@NgModule({
	providers: providers
})
export class WindowModule { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/native.ts